import { getRefreshToken } from '../../api/tokenStorage';

export const AUTH_ACTIONS = {
  SET_INITIALIZING: 'SET_INITIALIZING',
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  SET_USER: 'SET_USER',
};

export const initialAuthState = {
  user: null,
  isAuthenticated: false,
  isInitializing: !!getRefreshToken(),
};

export function authReducer(state, action) {
  switch (action.type) {
    case AUTH_ACTIONS.SET_INITIALIZING:
      return { ...state, isInitializing: action.payload.isInitializing };
    case AUTH_ACTIONS.LOGIN:
      return { ...state, user: action.payload.user, isAuthenticated: true, isInitializing: false };
    case AUTH_ACTIONS.LOGOUT:
      return { ...state, user: null, isAuthenticated: false, isInitializing: false };
    case AUTH_ACTIONS.SET_USER:
      return { ...state, user: action.payload.user };
    default:
      return state;
  }
}
